import { render, staticRenderFns } from "./PopupAddMenu.vue?vue&type=template&id=2a396390&"
import script from "./PopupAddMenu.vue?vue&type=script&lang=ts&"
export * from "./PopupAddMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PopupAddMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports